module.exports = __webpack_public_path__ + "static/media/0121_LE_PLAFOND_HAUTEUR_3000.3973c89e.webp";